import {
  testDialogFieldLabelSx,
  testDialogFieldShellSx,
} from '../components/tests/testDialogFieldStyles';

export const teacherFilterPanelSx = (isTop, stickyTop = 0) => ({
  p: isTop ? 2 : 3,
  borderRadius: isTop ? 1 : 3,
  height: 'fit-content',
  position: isTop ? 'static' : 'sticky',
  top: isTop ? 'auto' : stickyTop,
  backgroundColor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
});

export const teacherFilterHeaderSx = (isTop) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  mb: isTop ? 1.5 : 3,
});

export const teacherFilterTitleSx = (isTop) => ({
  fontWeight: 700,
  color: isTop ? 'primary.dark' : 'text.primary',
  textTransform: isTop ? 'uppercase' : 'none',
  letterSpacing: isTop ? '0.07em' : 0,
  fontSize: isTop ? '0.68rem' : undefined,
  lineHeight: 1.2,
});

export const teacherFilterClearButtonSx = {
  textTransform: 'none',
  color: 'primary.main',
  fontWeight: 600,
  '&:hover': { color: 'primary.dark' },
};

export const teacherFilterFieldSx = {
  ...testDialogFieldShellSx,
  '& .MuiOutlinedInput-root': {
    ...testDialogFieldShellSx['& .MuiOutlinedInput-root'],
    fontSize: '0.875rem',
    minHeight: 40,
  },
  '& .MuiInputLabel-root': {
    ...testDialogFieldLabelSx,
    px: 0.5,
    bgcolor: 'transparent',
    transform: 'translate(14px, 11px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(10px, -7px) scale(0.9)',
    },
  },
  '& .MuiSelect-select, & .MuiInputBase-input': {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  '& .MuiInputBase-input::placeholder': {
    color: 'text.secondary',
    opacity: 0.78,
  },
};

export const teacherFilterCompactFieldSx = {
  ...teacherFilterFieldSx,
  minWidth: { md: 170, lg: 180 },
};

export const teacherFilterTopStackSx = (fieldWidth = { md: 170, lg: 190 }) => ({
  '& .MuiTextField-root, & .MuiAutocomplete-root': {
    width: fieldWidth,
  },
});

export const teacherFilterToggleSx = (isTop) => ({
  minWidth: isTop ? 170 : 'auto',
  m: 0,
  mb: isTop ? 0 : 1,
  '& .MuiFormControlLabel-label': {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: 'text.primary',
  },
});

export const teacherFilterSectionLabelSx = {
  ...testDialogFieldLabelSx,
};
